export class NotificationType {
    public notificationTypeId: number;
    public notificationTypeName: string;
}